(function() {
    'use strict';

    var INITIALIZED_ATTR = 'data-intl-delivery-init';

    /**
     * Converts a data-source name to an API URL.
     * "international-delivery-countries" -> "/api/international-delivery/countries"
     * "some-other-source" -> "/api/some-other-source"
     */
    function sourceToUrl(source) {
        return '/api/' + source.replace(/-/g, '/') + 's';
    }

    function initInternationalDeliveryCountries() {
        var countrySelects = document.querySelectorAll('select[data-source="international-delivery-countries"]');
        
        countrySelects.forEach(function(select) {
            if (select.hasAttribute(INITIALIZED_ATTR)) {
                return;
            }
            
            var source = select.getAttribute('data-source');
            var sourceUrl = select.getAttribute('data-source-url');
            
            if (!sourceUrl && source) {
                sourceUrl = sourceToUrl(source);
            }
            
            if (!sourceUrl) {
                console.warn('No source URL found for international delivery countries select');
                return;
            }
            
            fetchCountries(select, sourceUrl);
        });
    }

    function fetchCountries(select, sourceUrl) {
        fetch(sourceUrl)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.status);
                }
                return response.json();
            })
            .then(function(data) {
                if (data.options && Array.isArray(data.options)) {
                    populateSelectOptions(select, data.options);
                    select.setAttribute(INITIALIZED_ATTR, 'true');
                    
                    var savedValue = select.getAttribute('data-previous-value');
                    if (savedValue) {
                        select.value = savedValue;
                    }
                    
                    var event = new Event('change', { bubbles: true });
                    select.dispatchEvent(event);
                }
            })
            .catch(function(error) {
                console.error('Error loading international delivery countries:', error);
            });
    }

    function populateSelectOptions(select, options) {
        while (select.options.length > 1) {
            select.remove(1);
        }
        
        options.forEach(function(option) {
            var opt = document.createElement('option');
            opt.value = option.value;
            opt.textContent = option.label;
            select.appendChild(opt);
        });
        
        var previousValue = select.getAttribute('data-previous-value') || select.dataset.selectedValue;
        if (previousValue) {
            select.value = previousValue;
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInternationalDeliveryCountries);
    } else {
        setTimeout(initInternationalDeliveryCountries, 100);
    }
    
    document.addEventListener('ajaxComplete', function(event) {
        setTimeout(initInternationalDeliveryCountries, 100);
    });

})();